import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Badge,
  ListGroup,
  ListGroupItem,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Button,
  UncontrolledPopover
} from 'reactstrap';
import { NavLink as NavLinkStrap } from 'reactstrap';
import { User, Bell } from 'react-feather';
import { toast } from 'react-toastify';
import { useHistory, NavLink } from 'react-router-dom';
import { signOutUser } from '../../components/auth/authActions';
import { clearDSZPriceNotification } from '../../components/myAccount/profileActions.js';
import clickFrenzyLogo from '../../assets/images/Sofortig_Notification_ClickFrenzy_380x80.png';
import { useSsoAuth } from '../../hooks/useSsoAuth';
import usersvg from '../../assets/images/icon/user_purple.svg';
import { downloadByLink } from '../../utils/download';
import priceReviewFile from '../../assets/files/Price_And_Shipping_Update_Summary_27112025.zip';
import promotionFile from '../../assets/files/Supplier_Product_Promotion_2711_1012_2025.xlsx';
import promotionFile2 from '../../assets/files/Supplier_Product_Promotion_0111_3112_2025.xlsx';
import promotionFile3 from '../../assets/files/Exclusive Luggage Deals_0511_0312_2025.xlsx';
import promotionFile4 from '../../assets/files/3 Weeks of Exclusive V1 Deals_2111_1012_2025.xlsx';

export function HeaderUserbox() {
  const dispatch = useDispatch();
  const { showFeatureItems5 } = useSelector((state) => state.ThemeOptions);
  const { shopname, email, dszEmail, token } = useSelector(
    (state) => state.auth
  );
  const { DszNotificationFlag } = useSelector((state) => state.profile);
  const history = useHistory();
  const isClickFrenzy = process.env.REACT_APP_IS_CLICK_FRENZY;
  const [enableDropDownOpen, setEnableDropDownOpen] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const [isMediumScreen, setIsMediumScreen] = useState(false);

  const enableButtonToggle = () =>
    setEnableDropDownOpen((prevState) => !prevState);

  const { ssoEnabled, ssoLogout } = useSsoAuth(dszEmail, token);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth > 1600);
      setIsMediumScreen(window.innerWidth > 1400 && window.innerWidth <= 1600);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  async function handleSignOut(e) {
    e.preventDefault();
    console.log('start handleSignOut');
    try {
      if (ssoEnabled) {
        const ssoLogoutRes = await ssoLogout();
        if (ssoLogoutRes) {
          const signout = await dispatch(signOutUser());
          if (signout) {
            history.push('/login');
          }
        } else {
          toast.error('sso logout failed, please retry later');
        }
      } else {
        const signout = await dispatch(signOutUser());
        if (signout) {
          localStorage.setItem('forceRefresh', 'true');
          history.push('/login');
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
  }

  const clearDszNotification = () => {
    dispatch(clearDSZPriceNotification());
  };

  const handleDownloadFile = (file, filename) => {
    downloadByLink(file, filename);
  };

  return (
    <>
      <div
        style={{
          paddingRight: '32px',
          display: 'flex',
          height: 'auto',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: '16px'
        }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            flex: 1,
            minWidth: '300px',
            maxWidth: '100%',
            margin: '5px 0px 5px 32px'
          }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              height: 'auto'
            }}>
            <div
              style={{
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                backgroundColor: '#942FFB',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '12px',
                flexShrink: 0
              }}>
              <span
                style={{
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}>
                i
              </span>
            </div>
            <div
              style={{
                color: '#942FFB',
                fontSize: '13px',
                flex: 1,
                wordBreak: 'break-word',
                overflowWrap: 'break-word'
              }}>
              Refresh your prices and stay ahead of the competition. The next
              Price Review takes effect on 27 Nov 2025.{' '}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleDownloadFile(priceReviewFile, 'Price_And_Shipping_Update_Summary_27112025.zip');
                }}
                style={{
                  color: '#942FFB',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap'
                }}>
                Download Now.
              </a>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              height: 'auto'
            }}>
            <div
              style={{
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                backgroundColor: '#942FFB',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '12px',
                flexShrink: 0
              }}>
              <span
                style={{
                  color: 'white',
                  fontSize: '13px',
                  fontWeight: 'bold'
                }}>
                i
              </span>
            </div>
            <div
              style={{
                color: '#942FFB',
                fontSize: '13px',
                flex: 1,
                wordBreak: 'break-word',
                overflowWrap: 'break-word'
              }}>
              Check the latest promotions and boost your sales. The next
              Promotion takes effect from 27 Nov to 10 Dec 2025.{' '}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleDownloadFile(promotionFile, 'Supplier_Product_Promotion_2711_1012_2025.xlsx');
                }}
                style={{
                  color: '#942FFB',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap'
                }}>
                Download Now.
              </a>
            </div>
          </div>
          {new Date() < new Date('2026-01-01') && <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              height: 'auto'
            }}>
            <div
              style={{
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                backgroundColor: '#942FFB',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '12px',
                flexShrink: 0
              }}>
              <span
                style={{
                  color: 'white',
                  fontSize: '13px',
                  fontWeight: 'bold'
                }}>
                i
              </span>
            </div>
            <div
              style={{
                color: '#942FFB',
                fontSize: '13px',
                flex: 1,
                wordBreak: 'break-word',
                overflowWrap: 'break-word'
              }}>
              Drive more sales with our exclusive 2-month promotion. Promotion period from 1 Nov to 31 Dec 2025. {' '}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleDownloadFile(promotionFile2, 'Supplier_Product_Promotion_0111_3112_2025.xlsx');
                }}
                style={{
                  color: '#942FFB',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap'
                }}>
                Download Now.
              </a>
            </div>
          </div>}
          {new Date() < new Date('2025-12-04') && <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              height: 'auto'
            }}>
            <div
              style={{
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                backgroundColor: '#942FFB',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '12px',
                flexShrink: 0
              }}>
              <span
                style={{
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}>
                i
              </span>
            </div>
            <div
              style={{
                color: '#942FFB',
                fontSize: '13px',
                flex: 1,
                wordBreak: 'break-word',
                overflowWrap: 'break-word'
              }}>
              Extended Exclusive Luggage Deals. Promotion period from 5 Nov to 3 Dec 2025.{' '}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleDownloadFile(promotionFile3, 'Exclusive Luggage Deals_0511_0312_2025.xlsx');
                }}
                style={{
                  color: '#942FFB',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap'
                }}>
                Download Now.
              </a>
            </div>
          </div>}

          {new Date() < new Date('2025-12-11') && <div
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              height: 'auto'
            }}>
            <div
              style={{
                width: '20px',
                height: '20px',
                borderRadius: '50%',
                backgroundColor: '#942FFB',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: '12px',
                flexShrink: 0
              }}>
              <span
                style={{
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}>
                i
              </span>
            </div>
            <div
              style={{
                color: '#942FFB',
                fontSize: '13px',
                flex: 1,
                wordBreak: 'break-word',
                overflowWrap: 'break-word'
              }}>
              3 weeks of exclusive V1 deals to boost your sales. Promotion period from 21 Nov to 10 Dec 2025.{' '}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleDownloadFile(promotionFile4, '3 Weeks of Exclusive V1 Deals_2111_1012_2025.xlsx');
                }}
                style={{
                  color: '#942FFB',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap'
                }}>
                Download Now.
              </a>
            </div>
          </div>}
        </div>
        {/* User Info */}
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            flexShrink: 0,
            paddingLeft: isLargeScreen
              ? '520px'
              : isMediumScreen
                ? '300px'
                : '30px',
            paddingBottom: '5px'
          }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end'
            }}>
            <img src={usersvg} alt="user icon"></img>
            <span
              style={{
                color: '#942FFB',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: '400',
                whiteSpace: 'nowrap',
                display: 'inline-block',
                direction: 'rtl',
                textAlign: 'left'
              }}>
              {dszEmail}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

export default HeaderUserbox;
